import { useEffect } from "react";

export const REMINDER_SETTING_KEY = "nse:reminders-enabled";

export function useDailyReminders(dueReviewCount: number) {
  useEffect(() => {
    if (!("Notification" in window)) return;

    const check = () => {
      if (localStorage.getItem(REMINDER_SETTING_KEY) !== "true" || Notification.permission !== "granted") return;
      const now = new Date();
      const hour = now.getHours();
      const minute = now.getMinutes();
      const date = new Intl.DateTimeFormat("en-CA", {
        timeZone: "Asia/Shanghai",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(now);
      const event = hour === 7 && minute === 55
        ? "morning"
        : hour === 20 && minute === 30
          ? "evening"
          : undefined;
      if (!event) return;
      const lastKey = `nse:reminder:${event}:${date}`;
      if (localStorage.getItem(lastKey)) return;
      localStorage.setItem(lastKey, new Date().toISOString());
      const morning = event === "morning";
      new Notification(morning ? "07:55 开工检查" : "20:30 晚间复盘", {
        body: morning
          ? `打开今日任务；当前有${dueReviewCount}道D1/D3/D7待回炉。`
          : "整理有效时长、题库数据、3个不会点及必要附件，然后回到Codex验收。",
        icon: "./icon-192.svg",
        tag: lastKey,
      });
    };

    check();
    const interval = window.setInterval(check, 30_000);
    return () => window.clearInterval(interval);
  }, [dueReviewCount]);
}
